<template>
  <div>
    <v-list-item v-for="n in unread" :key="n.ID">
      <v-list-item-content>
        <Notification :n="n"></Notification>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          color="secondary"
          outlined
          @click="markUnread(n)"
          v-if="n.IsAcknowledged"
        >
          Mark Unread</v-btn
        >
        <v-btn color="primary" @click="acknowledge(n)" v-else>Mark Read</v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-left"
          ><span> Previously Acknowledged </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list-item v-for="n in read" :key="n.ID">
            <v-list-item-content>
              <Notification :n="n"></Notification>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                color="secondary"
                outlined
                @click="markUnread(n)"
                v-if="n.IsAcknowledged"
              >
                Mark Unread</v-btn
              >
              <v-btn color="primary" @click="acknowledge(n)" v-else
                >Mark Read</v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'

import Notification from '@components/notifications/Notification.vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import download from 'downloadjs'
dayjs.extend(relativeTime)
export default {

  //model: {
  //	prop: ''
  //},
  props: {
    billNotifications: {
      Type: Array,
      required: true,
    },
  },
  components: { Notification },
  filters: {},
  data() {
    return {
      panel: [],
    }
  },
  created() {},
  computed: {
    bill() {
      if (this.billNotifications.length > 0) {
        return this.billNotifications[0].TrackedBill
      } else {
        return null
      }
    },
    unread() {
      return this.billNotifications.filter((x) => !x.IsAcknowledged)
    },
    read() {
      return this.billNotifications.filter((x) => x.IsAcknowledged)
    },
  },
  methods: {
    ...call('notification', ['acknowledge', 'markUnread', 'loadNotifications']),
  },
  watch: {},
}
</script>
<style scoped>
</style>